import { render, staticRenderFns } from "./FotoSocio.vue?vue&type=template&id=6b792610"
import script from "./FotoSocio.vue?vue&type=script&lang=js"
export * from "./FotoSocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports